<div>
	<div>
		<h4 class="primary">Most Popular Products</h4>
	</div>

	<!-- Loading State -->
	<div *ngIf="loading" class="flex justify-content-center align-items-center p-4">
		<mat-spinner [diameter]="50"></mat-spinner>
	</div>

	<!-- Empty State -->
	<div *ngIf="!loading && isEmpty" class="flex justify-content-center align-items-center p-4">
		<div class="text-center">
			<i class="pi pi-inbox text-4xl text-400 mb-3"></i>
			<p class="text-600">No data available for this period.</p>
		</div>
	</div>

	<!-- Data Table -->
	<table
		*ngIf="!loading && !isEmpty"
		mat-table
		[dataSource]="dataSource"
		matSort
		(matSortChange)="onPopularProductsSortChange($event)"
	>
		<!-- Product Name -->
		<ng-container matColumnDef="ProductName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Product</th>
			<td mat-cell *matCellDef="let element">
				<div>
					<img src="{{ element.ImageUrl }}" alt="" height="45" width="45" />
					<div>{{ element.ProductName }}</div>
				</div>
			</td>
		</ng-container>

		<!-- Quantity -->
		<ng-container matColumnDef="Quantity">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Quantity</th>
			<td mat-cell *matCellDef="let element">{{ element.Quantity }}</td>
		</ng-container>

		<!-- Sales Revenue -->
		<ng-container matColumnDef="SalesRevenue">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Revenue</th>
			<td mat-cell *matCellDef="let element">
				{{ element.SalesRevenue | currency : "PHP" }}
			</td>
		</ng-container>

		<!-- Header & Rows -->
		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>
